// @ngInject
function FeatureSwitchService($timeout, $rootScope, $q, DSHttpAdapter, DS, ResourcesService) {
    return {
        hasAdvancedReturnReason: hasAdvancedReturnReason,
        hasAdvancedImport: hasAdvancedImport,
        isAllowedToChangeColoursOnProducts: isAllowedToChangeColoursOnProducts,
        isBrandConnectEnabled: isBrandConnectEnabled
    };

    function hasAdvancedReturnReason() {
        var licenses = getLicense();
        var license = licenses['advancedreturnsmodule'];
        return (license !== undefined) ? license : false;
    }

    function hasAdvancedImport() 
    {
        var licenses = getLicense();
        var license = licenses['advancedimportmodule'];
        return (license !== undefined) ? license : false;
    }

    function isAllowedToChangeColoursOnProducts() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'products/isallowedtochangecolours').then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function isBrandConnectEnabled() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.rms2Path + 'features/FeatureBrandConnect').then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getLicense() {
        return $rootScope.currentUser.licenseConfig;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('services.featureSwitchService', [])
    .factory('FeatureSwitchService', FeatureSwitchService);
